module.exports = __webpack_public_path__ + "img/icon-tpvpos-w.ac853d81.svg";